var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlbumShareWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/icon/albums",
    transform: "translate(7.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    stroke: "#fff",
    x: 0.5,
    y: 0.5,
    width: 26,
    height: 18,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(14.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-6",
    points: "5.08538104 0 10.7721826 4.51704047 4.71087092 4.51704047 0.328327369 4.51704047"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mountain",
    stroke: "#fff",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.34375,4.72222222 L5.15625,0.277777778",
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15625,0.277777778 L10.65625,4.72222222",
    id: "Line-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(2.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 1.100000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-6",
    points: "7.85922525 0 16.6479186 8.94374014 7.28043688 8.94374014 0.507415024 8.94374014"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mountain",
    stroke: "#fff",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.53125,9.35 L7.96875,0.55",
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96875,0.55 L16.46875,9.35",
    id: "Line-3"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    stroke: "#535453",
    fill: "#FFFFFF",
    cx: 16.5,
    cy: 4.5,
    r: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbumShareWhite);
export default __webpack_public_path__ + "static/media/album-share-white.258c05564f5dd395302e0892d14c928d.svg";
export { ForwardRef as ReactComponent };